fragment EntityAttributeBase on EntityAttribute {
    id
    attribute {
        name
        displayName
        type
        description
    }
}

fragment EntityAttribute on EntityAttribute {
    ...EntityAttributeBase
    ... on EntityAttributeEnum {
        ...EntityAttributeEnum
    }
    ... on EntityAttributeCurrency {
        ...EntityAttributeCurrency
    }
}

fragment EntityAttributeEnum on EntityAttributeEnum {
    ...EntityAttributeBase
    options {
        id
        name
    }
    allowMultiple
}

fragment EntityAttributeCurrency on EntityAttributeCurrency {
    ...EntityAttributeBase
    currencyOptions
    defaultCurrency
}

fragment EntityAttributeValue on EntityAttributeValue {
    ... on EntityAttributeValueString {
        ...EntityAttributeValueString
    }
    ... on EntityAttributeValueText {
        ...EntityAttributeValueText
    }
    ... on EntityAttributeValueEnum {
        ...EntityAttributeValueEnum
    }
    ... on EntityAttributeValueDate {
        ...EntityAttributeValueDate
    }
    ... on EntityAttributeValueset {
        ...EntityAttributeValueValueset
    }
    ... on EntityAttributeValueEmail {
        ...EntityAttributeValueEmail
    }
    ... on EntityAttributeValuePhone {
        ...EntityAttributeValuePhone
    }
    ... on EntityAttributeValueLocation {
        ...EntityAttributeValueLocation
    }
    ... on EntityAttributeValueFile {
        ...EntityAttributeValueFile
    }
    ... on EntityAttributeValueCurrency {
        ...EntityAttributeValueCurrency
    }
    ... on EntityAttributeValueImage {
        ...EntityAttributeValueImage
    }
    ... on EntityAttributeValueUrl {
        ...EntityAttributeValueUrl
    }
}

fragment EntityAttributeValueString on EntityAttributeValueString {
    value
}

fragment EntityAttributeValueText on EntityAttributeValueText {
    value
}

fragment EntityAttributeValueEnum on EntityAttributeValueEnum {
    value
}

fragment EntityAttributeValueDate on EntityAttributeValueDate {
    date
}

fragment EntityAttributeValueValueset on EntityAttributeValueset {
    all {
        ... on EntityAttributeValueString {
            ...EntityAttributeValueString
        }
        ... on EntityAttributeValueText {
            ...EntityAttributeValueText
        }
        ... on EntityAttributeValueEnum {
            ...EntityAttributeValueEnum
        }
        ... on EntityAttributeValueDate {
            ...EntityAttributeValueDate
        }
        ... on EntityAttributeValueEmail {
            ...EntityAttributeValueEmail
        }
        ... on EntityAttributeValuePhone {
            ...EntityAttributeValuePhone
        }
        ... on EntityAttributeValueLocation {
            ...EntityAttributeValueLocation
        }
        ... on EntityAttributeValueFile {
            ...EntityAttributeValueFile
        }
        ... on EntityAttributeValueCurrency {
            ...EntityAttributeValueCurrency
        }
        ... on EntityAttributeValueImage {
            ...EntityAttributeValueImage
        }
        ... on EntityAttributeValueUrl {
            ...EntityAttributeValueUrl
        }
    }
}

fragment EntityAttributeValueEmail on EntityAttributeValueEmail {
    address
    display
}

fragment EntityAttributeValuePhone on EntityAttributeValuePhone {
    E164
    countryCode
    extension
    number
    numberFormatted
    numberFormattedWithCountryCode
}

fragment EntityAttributeValueLocation on EntityAttributeValueLocation {
    address_1
    address_2
    address_3
    city
    state
    postalCode
    country
    region
    fullAddress
    fullAddressAllFields
    coordinates {
        latitude
        longitude
        accuracy
    }
}

fragment EntityAttributeValueFile on EntityAttributeValueFile {
    fileId
    nutFile {
        slug
        filename
        url
    }
    uploadedTime
    name
    size
    href
    viewHref
    viewableInBrowser
    fileType
}

fragment EntityAttributeValueCurrency on EntityAttributeValueCurrency {
    currencyValue {
        amount
        currency
        symbol
        formatted
        formattedWithCents
        formattedValue {
            value
            suffix
            prefix
            formatted
            unit
        }
    }
}

fragment EntityAttributeValueImage on EntityAttributeValueImage {
    fileId
    name
    size
    href
    fileType
    imageUrl
}

fragment EntityAttributeValueUrl on EntityAttributeValueUrl {
    display
    value
}
